import { AllFlagsDTO } from '../models/AllFlagsDTO'
import { FlagsRepository } from '../repositories/flagsRepository'

export function UpdateAllFlagsCase(repository: FlagsRepository) {
  return async function (data: AllFlagsDTO) {
    return await repository.updateAllFlags(data)
  }
}
